<script setup lang="ts">
import { useYourDetailsStore, Title, MaritalStatus } from "../stores/yourDetails";
import Question from "./fields/Question.vue";
import Input from "./fields/Input.vue";
import Select from "./fields/Select.vue";
import DatePicker from "./fields/DatePicker.vue";
import { yourDetailsValidator as validator, dobMinDate, dobMaxDate } from "../utils/validators";
import { tooltips } from "../tooltips/yourDetailsTooltips";
import { LINKS } from "../constants/links";
import { gender } from "@/composables/aboutYou";

const store = useYourDetailsStore();
</script>

<template>
    <Question
        name="title"
        label="Title"
    >
        <Select
            v-model.number="store.title"
            placeholder="Title"
            input-class="input-width-auto"
            :options="[
                {value: Title.Mr, label: 'Mr'},
                {value: Title.Miss, label: 'Miss'},
                {value: Title.Mrs, label: 'Mrs'},
                {value: Title.Ms, label: 'Ms'},
                {value: Title.Sir, label: 'Sir'},
                {value: Title.DrMale, label: 'Dr (Male)'},
                {value: Title.DrFemale, label: 'Dr (Female)'}]"
            :validation="validator.title"
            @update:model-value="() => store.sex = gender(store.title)"
        />
    </Question>
    <Question
        type="group"
        name="fullName"
        label="Full name"
        :tooltip="tooltips.fullName"
    >
        <Input
            id="forename"
            v-model="store.forename"
            hidden-label="Forename"
            placeholder="Forename"
            type="text"
            :validation="validator.forename"
        />
        <Input
            id="surname"
            v-model="store.surname"
            hidden-label="Surname"
            placeholder="Surname"
            type="text"
            :validation="validator.surname"
        />
    </Question>
    <Question
        name="emailaddress"
        label="Email address"
        :tooltip="tooltips.email"
    >
        <Input
            v-model="store.email"
            placeholder="email"
            type="email"
            :validation="validator.email"
        />
    </Question>
    <Question
        type="group"
        name="dob"
        label="Date of birth"
        input-class="col-12 col-md-11 col-lg-9"
        :tooltip="tooltips.dob"
    >
        <DatePicker
            v-model="store.dob"
            :min-date="dobMinDate"
            :max-date="dobMaxDate"
            :validation="validator.dob"
        />
    </Question>
    <Question
        name="postcode"
        label="Postcode"
        :tooltip="tooltips.postcode"
    >
        <Input
            v-model="store.postcode"
            placeholder="Postcode"
            input-class="input-width-auto"
            type="text"
            :validation="validator.postcode"
        />
    </Question>
    <Question
        name="maritalStatus"
        label="Marital status"
    >
        <Select
            v-model.number="store.maritalStatus"
            placeholder="Please select"
            input-class="input-width-auto"
            :options="[
                {value: MaritalStatus.Married, label: 'Married'},
                {value: MaritalStatus.Divorced, label: 'Divorced'},
                {value: MaritalStatus.Separated, label: 'Separated'},
                {value: MaritalStatus.Single, label: 'Single'},
                {value: MaritalStatus.Widowed, label: 'Widowed'},
                {value: MaritalStatus.CivilPartnership, label: 'Civil partnership'},
                {value: MaritalStatus.DissolvedCivilPartnership, label: 'Dissolved civil partnership'},
                {value: MaritalStatus.Cohabiting, label: 'Cohabiting'},
                {value: MaritalStatus.SurvivingCivilPartnership, label: 'Surviving civil partnership'} ]"
            :validation="validator.maritalStatus"
        />
    </Question>
    <div class="telephone-card">
        <p><strong>We're here to help:</strong> By sharing your telephone number, we can get in touch to support you with your quote and make sure you have everything you need.</p>
        <Question
            name="phone"
            label="Telephone"
        >
            <Input
                v-model="store.phone"
                placeholder="Telephone"
                inputmode="numeric"
                type="text"
                :validation="validator.phone"
            />
        </Question>
        <p><strong>Need to speak to someone now?</strong></p>
        <p>You can call us on <a href="tel:08003265479">0800 326 5479</a>. Our team is here to help and committed to ensuring you receive the guidance you need.</p>
    </div>
    <div>
        <h5 class="blue">
            Privacy and consent
        </h5>
        By clicking the ‘Agree and continue’ button, I/we consent to Annuity Ready processing the information including
        lifestyle, health and medical details that I/we provide, in accordance with the Annuity Ready
        <a
            :href="LINKS.ANNUITY_TERMS_AND_CONDITIONS_DOCUMENT_LINK"
            target="_blank"
        >terms &amp; conditions</a> and
        <a
            :href="LINKS.ANNUITY_PRIVACY_NOTICE_DOCUMENT_LINK"
            target="_blank"
        >privacy notice</a>
        which contains details of providers with whom they may share the data to obtain annuity quotes.
    </div>
</template>
